import { useStore } from "vuex";
import { computed } from "vue";
import { TeamState, TeamStudentState } from "@/store/teams/state";
import { MODULES, vuexName } from "@/store/utils";
export const useManipulateTeamState = () => {
  const { getters, dispatch, commit } = useStore();
  const isTeamMode = computed<boolean>(() => getters[vuexName(MODULES.TEAMS.GETTERS.GET_IS_TEAM_MODE)]);
  const isFetchingTeams = computed<boolean>(() => getters[vuexName(MODULES.TEAMS.GETTERS.GET_IS_LOADING)]);
  const allStudents = computed<TeamStudentState[]>(() => getters[vuexName(MODULES.TEAMS.GETTERS.GET_ALL_STUDENTS)]);
  const teams = computed<TeamState[]>(() => getters[vuexName(MODULES.TEAMS.GETTERS.GET_TEAMS)]);
  const settingModalOpened = computed<boolean>(() => getters[vuexName(MODULES.TEAMS.GETTERS.GET_IS_SETTING_MODAL_OPEN)]);
  const enableTeamModeOnSave = computed<boolean>(() => getters[vuexName(MODULES.TEAMS.GETTERS.GET_IS_ENABLE_TEAM_MODE_ON_SAVE)]);
  //** List students who are not on any team */
  const nonTeamStudents = computed<TeamStudentState[]>(() =>
    allStudents.value.filter(
      (s) =>
        teams.value
          .map((team) => team.students.map((s) => s.id))
          .flat()
          .findIndex((id) => id === s.id) === -1,
    ),
  );
  const findTeamByStudentId = (studentId: string) => teams.value.find((t) => t.students.findIndex((ts) => ts.id === studentId) > -1);
  const toggleTeamMode = async () => {
    await dispatch(vuexName(MODULES.TEAMS.DISPATCHES.TOGGLE_TEAM_MODE_ASYNC), !isTeamMode.value);
  };
  const settingTeams = async (enableTeamOnSave = false) => {
    if (enableTeamOnSave) commit(vuexName(MODULES.TEAMS.COMMITS.SET_IS_ENABLE_TEAM_MODE_ON_SAVE), true);
    commit(vuexName(MODULES.TEAMS.COMMITS.SET_IS_SETTING_MODAL_OPEN), true);
  };
  return {
    getters,
    dispatch,
    commit,
    isTeamMode,
    isFetchingTeams,
    teams,
    allStudents,
    nonTeamStudents,
    findTeamByStudentId,
    toggleTeamMode,
    settingModalOpened,
    enableTeamModeOnSave,
    settingTeams,
  };
};
